import { Button } from "@/components/ui/button"
import { H3, H4, Small } from "@/components/ui/typography"
import { ShieldCheck } from "lucide-react"
import PDFIcon from "@/assets/pdf.svg"
import React, { useEffect } from "react"
import { Card } from "@/components/ui/card"
import PaywallImg from "@/assets/paywall.png"

type PaywallProps = {
	price: string
	dateRange: string
	onPayClick: () => void
	title: string
	subtitle: string
	buttonText: string
	securePaymentText: string
	isProcessingPayment: boolean
	onPaywallOpen: () => void
}

export const Paywall: React.FC<PaywallProps> = ({
	price,
	dateRange,
	onPayClick,
	title,
	subtitle,
	buttonText,
	securePaymentText,
	isProcessingPayment,
	onPaywallOpen,
}) => {
	useEffect(() => {
		onPaywallOpen()
	}, [])
	return (
		<div className="flex flex-col gap-4 max-w-md">
			<Card
				className="rounded-lg p-5"
				style={{
					background: `linear-gradient(320deg, rgba(241, 245, 249, 0.00) 15.39%, #F1F5F9 87.65%), url(${PaywallImg}) transparent 50%`,
					backgroundSize: "cover",
					backgroundRepeat: "no-repeat",
				}}
			>
				<Card className="w-[120px] h-[130px] bg-white rounded-lg flex flex-col items-center justify-center">
					<img src={PDFIcon} alt="PDF" className="w-[56px]" />
					<H4 className="text-black font-normal mt-2.5">PDF</H4>
				</Card>
			</Card>

			<div className="text-left">
				<H3 className="">
					{title} <span className="text-primary">{price}</span>
				</H3>
				<Small className="text-muted-foreground font-normal">
					{subtitle}
					<br />
					{dateRange}
				</Small>
			</div>

			<Button
				className="w-full text-primary-foreground"
				size={"lg"}
				onClick={onPayClick}
				disabled={isProcessingPayment}
			>
				{buttonText}
			</Button>

			<div className="flex items-center gap-1 text-muted-foreground justify-center">
				<ShieldCheck className="w-4 h-4 opacity-50" color="#5BB98B" />
				<Small className=" text-[#5BB98B] font-normal">{securePaymentText}</Small>
			</div>
		</div>
	)
}

// const CheckoutForm: React.FC<{ client: string }> = (props) => {
// 	const stripe = useStripe()
// 	const elements = useElements()

// 	const [message, setMessage] = useState<string | null>(null)
// 	const [isLoading, setIsLoading] = useState(false)
// 	React.useEffect(() => {
// 		//@ts-ignore
// 		window.t = () =>
// 			stripe?.retrievePaymentIntent(props.client).then(({ paymentIntent }) => {
// 				if (!paymentIntent) {
// 					return
// 				}
// 			})
// 	}, [stripe])
// 	const handleSubmit = async (e: any) => {
// 		e.preventDefault()

// 		if (!stripe || !elements) {
// 			// Stripe.js hasn't yet loaded.
// 			// Make sure to disable form submission until Stripe.js has loaded.
// 			return
// 		}

// 		setIsLoading(true)

// 		const { error } = await stripe.confirmPayment({
// 			elements,
// 			confirmParams: {
// 				// Make sure to change this to your payment completion page
// 				return_url: "http://localhost:3000/complete",
// 			},
// 		})

// 		// This point will only be reached if there is an immediate error when
// 		// confirming the payment. Otherwise, your customer will be redirected to
// 		// your `return_url`. For some payment methods like iDEAL, your customer will
// 		// be redirected to an intermediate site first to authorize the payment, then
// 		// redirected to the `return_url`.
// 		if (error.type === "card_error" || error.type === "validation_error") {
// 			setMessage(error.message || null)
// 		} else {
// 			setMessage("An unexpected error occurred.")
// 		}

// 		setIsLoading(false)
// 	}

// 	return (
// 		<form id="payment-form" onSubmit={handleSubmit}>
// 			<PaymentElement id="payment-element" options={{ layout: "accordion" }} />
// 			<button disabled={isLoading || !stripe || !elements} id="submit">
// 				<span id="button-text">
// 					{isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
// 				</span>
// 			</button>
// 			{/* Show any error or success messages */}
// 			{message && <div id="payment-message">{message}</div>}
// 		</form>
// 	)
// }
